const APPROVED_TOKEN_KEY = "cadlogin_approved_token";

export function saveApprovedToken(token) {
  localStorage.setItem(APPROVED_TOKEN_KEY, token);
}

export function getApprovedToken() {
  return localStorage.getItem(APPROVED_TOKEN_KEY);
}

export function removeApprovedToken() {
  localStorage.removeItem(APPROVED_TOKEN_KEY);
}

export function isApprovedAuthenticated() {
  return Boolean(getApprovedToken());
}
